import { KYMW9002Model } from '../kymw9002.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ユーザー詳細情報を取得する
 *
 * @export API通信成功時の処理
 * @class GetUserInfomationDetailService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetUserInfomationDetailService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9002Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetUserInfomationDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        UserID: this.vo.userID,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9002Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetUserInfomationDetailService
   */
  execute(model: KYMW9002Model, vo: any, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getUserInfomationDetail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUserInfomationDetailService
   */
  success(data: any) {
    this.model.updateUserInformationDeatil(data);
    // 権限コンボボックス位置づけ
    this.model.kymw9002Component.setAuthorityCmb(this.model.userInfo.AuthoritySetID);
  }

}
